// Achievement-Definitionen (Anzeige). Die Berechnung läuft in
// functions/achievements.js mit der Kopie functions/achievementDefinitions.js –
// beide Dateien gemeinsam ändern.

export const LIFETIME_BADGES = {
  statistiker: {
    id: 'statistiker',
    name: 'Statistiker',
    emoji: '📊',
    beschreibung: 'Anzahl getippter Spiele',
    stufen: [
      { id: 'rookie', name: 'Rookie', emoji: '🟤', wert: 50, punkte: 10 },
      { id: 'sophomore', name: 'Sophomore', emoji: '🟠', wert: 120, punkte: 25 },
      { id: 'veteran', name: 'Veteran', emoji: '🥉', wert: 300, punkte: 50 },
      { id: 'allPro', name: 'All-Pro', emoji: '🥈', wert: 600, punkte: 100 },
      { id: 'mvp', name: 'MVP', emoji: '🥇', wert: 1000, punkte: 200 },
      { id: 'hofamer', name: 'Hall-of-Famer', emoji: '💎', wert: 1800, punkte: 400 },
      { id: 'goat', name: 'GOAT', emoji: '🐐', wert: 3000, punkte: 1000 }
    ]
  },
  
  exaktMeister: {
    id: 'exaktMeister',
    name: 'Exakt-Meister',
    emoji: '💎',
    beschreibung: 'Anzahl exakter Tipps',
    stufen: [
      { id: 'rookie', name: 'Rookie', emoji: '🟤', wert: 5, punkte: 10 },
      { id: 'sophomore', name: 'Sophomore', emoji: '🟠', wert: 12, punkte: 25 },
      { id: 'veteran', name: 'Veteran', emoji: '🥉', wert: 30, punkte: 50 },
      { id: 'allPro', name: 'All-Pro', emoji: '🥈', wert: 60, punkte: 100 },
      { id: 'mvp', name: 'MVP', emoji: '🥇', wert: 120, punkte: 200 },
      { id: 'hofamer', name: 'Hall-of-Famer', emoji: '💎', wert: 200, punkte: 400 },
      { id: 'goat', name: 'GOAT', emoji: '🐐', wert: 350, punkte: 1000 }
    ]
  },
  
  streakLegende: {
    id: 'streakLegende',
    name: 'Streak-Legende',
    emoji: '🔥',
    beschreibung: 'Längste Streak aller Zeiten',
    stufen: [
      { id: 'rookie', name: 'Rookie', emoji: '🟤', wert: 3, punkte: 10 },
      { id: 'sophomore', name: 'Sophomore', emoji: '🟠', wert: 6, punkte: 25 },
      { id: 'veteran', name: 'Veteran', emoji: '🥉', wert: 10, punkte: 50 },
      { id: 'allPro', name: 'All-Pro', emoji: '🥈', wert: 15, punkte: 100 },
      { id: 'mvp', name: 'MVP', emoji: '🥇', wert: 20, punkte: 200 },
      { id: 'hofamer', name: 'Hall-of-Famer', emoji: '💎', wert: 28, punkte: 400 },
      { id: 'goat', name: 'GOAT', emoji: '🐐', wert: 40, punkte: 1000 }
    ]
  },
  
  veteran: {
    id: 'veteran',
    name: 'Veteran',
    emoji: '🏈',
    beschreibung: 'Anzahl Saisons (mit Regular + Playoff)',
    stufen: [
      { id: 'rookie', name: 'Rookie', emoji: '🟤', wert: 1, punkte: 10 },
      { id: 'sophomore', name: 'Sophomore', emoji: '🟠', wert: 2, punkte: 25 },
      { id: 'veteran', name: 'Veteran', emoji: '🥉', wert: 4, punkte: 50 },
      { id: 'allPro', name: 'All-Pro', emoji: '🥈', wert: 7, punkte: 100 },
      { id: 'mvp', name: 'MVP', emoji: '🥇', wert: 10, punkte: 200 },
      { id: 'hofamer', name: 'Hall-of-Famer', emoji: '💎', wert: 13, punkte: 400 },
      { id: 'goat', name: 'GOAT', emoji: '🐐', wert: 15, punkte: 1000 }
    ]
  },
  
  bonusJaeger: {
    id: 'bonusJaeger',
    name: 'Bonus-Jäger',
    emoji: '⚡',
    beschreibung: 'Bonusfragen-Punkte gesamt',
    stufen: [
      { id: 'rookie', name: 'Rookie', emoji: '🟤', wert: 100, punkte: 10 },
      { id: 'sophomore', name: 'Sophomore', emoji: '🟠', wert: 250, punkte: 25 },
      { id: 'veteran', name: 'Veteran', emoji: '🥉', wert: 600, punkte: 50 },
      { id: 'allPro', name: 'All-Pro', emoji: '🥈', wert: 1200, punkte: 100 },
      { id: 'mvp', name: 'MVP', emoji: '🥇', wert: 2500, punkte: 200 },
      { id: 'hofamer', name: 'Hall-of-Famer', emoji: '💎', wert: 4500, punkte: 400 },
      { id: 'goat', name: 'GOAT', emoji: '🐐', wert: 8000, punkte: 1000 }
    ]
  },
  
  communityMitglied: {
    id: 'communityMitglied',
    name: 'Community-Mitglied',
    emoji: '👤',
    beschreibung: 'Grundlegende Aktivitäten',
    stufen: [
      { id: 'rookie', name: 'Rookie', emoji: '🟤', task: 'account', beschreibung: 'Account erstellt', punkte: 10 },
      { id: 'sophomore', name: 'Sophomore', emoji: '🟠', task: 'notifications', beschreibung: 'Push-Benachrichtigungen aktiviert', punkte: 25 },
      { id: 'veteran', name: 'Veteran', emoji: '🥉', task: 'favoriteTeam', beschreibung: 'Favoriten-Team ausgewählt', punkte: 50 },
      { id: 'allPro', name: 'All-Pro', emoji: '🥈', task: 'boardPost', beschreibung: 'Board-Eintrag verfasst', punkte: 100 },
      { id: 'mvp', name: 'MVP', emoji: '🥇', task: 'week1Tip2026', beschreibung: 'Week 1 Tipp ab Saison 2026/27', punkte: 200 },
      { id: 'hofamer', name: 'Hall-of-Famer', emoji: '💎', task: '10seasons', beschreibung: '10+ Saisons dabei', punkte: 400 },
      { id: 'goat', name: 'GOAT', emoji: '🐐', task: 'founding', beschreibung: 'Anmeldung vor 2026/27 (Gründungsmitglied)', punkte: 1000 }
    ]
  }
};

export const SAISON_BADGES = {
  perfekteWoche: {
    id: 'perfekteWoche',
    name: 'Perfekte Woche',
    emoji: '🎯',
    beschreibung: 'Alle Spiele einer Woche exakt',
    stufen: [
      { id: 'i', emoji: '⭐', wert: 1, punkte: 10 },
      { id: 'ii', emoji: '⭐⭐', wert: 2, punkte: 10 },
      { id: 'iii', emoji: '⭐⭐⭐', wert: 3, punkte: 10 },
      { id: 'iv', emoji: '⭐⭐⭐⭐', wert: 4, punkte: 10 },
      { id: 'v', emoji: '🔥', wert: 5, punkte: 10 }
    ]
  },
  
  blitzStart: {
    id: 'blitzStart',
    name: 'Blitz-Start',
    emoji: '⚡',
    beschreibung: 'Week 1 perfekt (alle richtig)',
    einmalig: true,
    punkte: 10
  },
  
  hotStreak: {
    id: 'hotStreak',
    name: 'Hot Streak',
    emoji: '🔥',
    beschreibung: 'In Folge richtig in dieser Saison',
    stufen: [
      { id: 'i', emoji: '🔥', wert: 5, punkte: 10 },
      { id: 'ii', emoji: '🔥🔥', wert: 10, punkte: 10 },
      { id: 'iii', emoji: '🔥🔥🔥', wert: 15, punkte: 10 },
      { id: 'iv', emoji: '🔥🔥🔥🔥', wert: 20, punkte: 10 },
      { id: 'v', emoji: '🔥🔥🔥🔥🔥', wert: 25, punkte: 10 },
      { id: 'vi', emoji: '💥', wert: 30, punkte: 10 }
    ]
  },
  
  playoffProphet: {
    id: 'playoffProphet',
    name: 'Playoff-Prophet',
    emoji: '🏆',
    beschreibung: 'Alle Playoff-Spiele richtig',
    einmalig: true,
    punkte: 10
  },
  
  vollstaendig: {
    id: 'vollstaendig',
    name: 'Vollständig',
    emoji: '💯',
    beschreibung: 'Alle Spiele der Saison getippt',
    einmalig: true,
    punkte: 10
  },
  
  ueberflieger: {
    id: 'ueberflieger',
    name: 'Überflieger',
    emoji: '🎓',
    beschreibung: 'Höchste Punktzahl in einer Woche',
    stufen: [
      { id: 'i', emoji: '🎓', wert: 1, punkte: 10 },
      { id: 'ii', emoji: '🎓🎓', wert: 3, punkte: 10 },
      { id: 'iii', emoji: '🎓🎓🎓', wert: 5, punkte: 10 },
      { id: 'iv', emoji: '🎓🎓🎓🎓', wert: 7, punkte: 10 },
      { id: 'v', emoji: '👑', wert: 10, punkte: 10 }
    ]
  }
};